import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ページ遷移時に自動的にスクロール位置を調整するコンポーネント
 */
function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (!hash) {
      // 他ページ遷移時は即座に最上部へ移動してから描画
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
      return
    }

    const MAX_ATTEMPTS = 6
    const RETRY_INTERVAL = 80
    let attempts = 0
    let retryTimeout: number | undefined

    const scrollToHash = () => {
      const targetId = hash.replace('#', '')
      const element = document.getElementById(targetId)
      if (!element) return false

      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return true
    }

    const tryScroll = () => {
      if (scrollToHash()) return
      if (attempts >= MAX_ATTEMPTS) {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
        return
      }
      attempts += 1
      retryTimeout = window.setTimeout(tryScroll, RETRY_INTERVAL)
    }

    tryScroll()

    return () => {
      if (retryTimeout) {
        clearTimeout(retryTimeout)
      }
    }
  }, [pathname, hash])

  return null
}

export default ScrollToTop

